import { destr } from 'destr'

const paymentRepository = (fetch: CustomFetch) => ({
  async getPricePlans() {
    return fetch<Omit<PricePlan, 'name'>[]>(`/v2/businesses/price_plans`, { parseResponse: destr })
  },
  async createPaymentIntent(businessId: string, paymentIntentPayload: PaymentIntentPayload, signal?: AbortSignal) {
    return fetch<SubscriptionPaymentIntent>(`/v2/businesses/${businessId}/subscriptions/payment_intent`, {
      method: 'POST',
      body: objectToSnakeCase(paymentIntentPayload),
      parseResponse: destr,
      signal,
    })
  },
  async createDirectPaymentIntent(paymentIntentPayload: PaymentIntentPayload, signal?: AbortSignal) {
    return fetch<SubscriptionPaymentIntent>(`/v2/businesses/direct_upgrade/payment_intent`, {
      method: 'POST',
      body: objectToSnakeCase(paymentIntentPayload),
      parseResponse: destr,
      signal,
    })
  },
  async upgradeTrial(businessId: string, type: string) {
    return fetch<null>(`/v2/businesses/${businessId}/subscriptions/trial`, {
      method: 'PUT',
      body: objectToSnakeCase({ type }),
      parseResponse: destr,
    })
  },
  async directUpgradeSubscription(upgradePayload: DirectUpgradeSubscriptionPayload) {
    return fetch<BusinessData>(`/v2/businesses/direct_upgrade/confirm`, {
      method: 'POST',
      body: objectToSnakeCase(upgradePayload),
      parseResponse: destr,
    })
  },
  async previewUpgradeSubscriptionPrice(
    businessId: string,
    type: PricePlanId,
    cycle: string,
    seats: number,
    currency: Currency,
    coupon: string,
    signal?: AbortSignal
  ) {
    const payload = objectToSnakeCase({
      type,
      cycle,
      seats,
      currency,
      coupon,
    })

    return fetch<PaymentPreview>(`/v2/businesses/${businessId}/subscriptions/upgrade/preview`, {
      method: 'POST',
      body: payload,
      parseResponse: destr,
      signal,
    })
  },
  async previewSeatsUpgradePrice(businessId: string, seats: number) {
    return fetch<PaymentPreview>(`/v2/businesses/${businessId}/subscriptions/seats/preview`, {
      method: 'POST',
      body: { seats },
      parseResponse: destr,
    })
  },
  async validateCoupon(businessId: string, couponId: string) {
    const payload = objectToSnakeCase({ couponId })
    // FIXME: resource naming
    return fetch<ValidateCouponResponse>(`/v2/businesses/${businessId}/subscriptions/coupons/validate_promo`, {
      method: 'POST',
      body: payload,
      parseResponse: destr,
    })
  },
  async getCurrentPaymentMethod(businessId: string): Promise<CardDetails | null> {
    return fetch<CardDetails | null>(`/v2/businesses/${businessId}/billing/card`)
  },
  async getActiveSubscription(businessId: string): Promise<string | null> {
    return fetch<string | null>(`/v2/businesses/${businessId}/subscriptions/active`)
  },
  async getCreditsBalance(businessId: string): Promise<number | null> {
    return fetch<number | null>(`/v2/businesses/${businessId}/subscriptions/starter_credits`)
  },
})

export default paymentRepository
